<template>
  <CModal
      :show.sync="viewTicketAnswerModal"
      :centered="true"
      title="مشاهده پاسخ تیکت"
      size="md"
      class="text-right"
  >
    <CRow class="px-2">
      <CCol sm="6" class="text-right">
        <div class="mb-3"><span class="bold">توسط:</span>
          {{ ticket.teacher.name }} {{ ticket.teacher.lastname }}
        </div>
      </CCol>
      <CCol sm="6" class="text-right">
        <div class="mb-3"><span class="bold">تاریخ ارسال:</span> {{ responseDate }}</div>

      </CCol>
    </CRow>
    <CRow class="px-2">
      <CCol sm="12" class="response-desc text-right">
        <div class="bold mb-2">پاسخ مدیر:</div>
        {{ ticket.response }}
      </CCol>
    </CRow>
    <template #footer>
      <CButton
          @click="viewTicketAnswerModal = false"
          color="danger"
          class="px-5"
      >
        بستن
      </CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    ticket: {
      type: Object,
    }
  },
  computed: {
    viewTicketAnswerModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    responseDate() {
      return this.ticket.responseDate.replaceAll('-', '/')
    },
  },
};
</script>

<style lang="scss" scoped>
.response-desc {
  word-wrap: break-word;
  white-space: pre-line;
}
</style>